/**
 * The API's OAuth `/oauth/authorize` (remote MCP connector) bounces a
 * signed-out user to `/sign-in?returnTo=<that authorize URL>`. After a
 * successful login we send the browser straight back there so the OAuth
 * round-trip to claude.ai completes.
 *
 * Only our own API's authorize endpoint is honoured: anything else would let
 * a crafted sign-in link land a fresh session on an attacker's site.
 */
export function oauthReturnTo(
  returnTo: string | undefined,
  apiBaseUrl: string,
): string | undefined {
  if (!returnTo) return undefined
  try {
    const api = new URL(apiBaseUrl, window.location.origin)
    // No base on purpose: a relative returnTo throws here and is rejected,
    // so only an absolute URL can ever match the API origin below.
    const target = new URL(returnTo)
    return target.origin === api.origin &&
      target.pathname === "/oauth/authorize"
      ? returnTo
      : undefined
  } catch {
    return undefined
  }
}
